import secureLocalStorage from 'react-secure-storage';
import api from '../../../api/index'

export function ivrCall(sd,ed) {
  return api.get(`v1.0/exotel/missed_call_data?startDate=${sd}T18%3A30%3A00.000Z&endDate=${ed}T18%3A29%3A59.999Z&rep_id=${secureLocalStorage.getItem("id")})`);
}
